export enum ServerType {
  GENERIC = 'generic',
  GEOSERVER = 'geoserver',
  MAPSERVER = 'mapserver',
}
